import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from './Model';

export interface IBusinessLineModel extends IModel {
  businessLineId: number;
  name: string;
}

export class BusinessLineModel
  extends Model
  implements ModelRecord<IBusinessLineModel>
{
  businessLineId: number;
  name: string;

  constructor(params?: Partial<IBusinessLineModel>) {
    super(params);

    this.businessLineId = defaultTo(params?.businessLineId, 0);
    this.name = defaultTo(params?.name, '');
  }
}
